import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MerchantService } from '../../../services/merchant.service'
import { AuthenticationService } from '../../../services/authentication.service'
import { EmailVerificationToken } from '@parkupp/core'

@Component({
    selector: 'app-verify-email-page',
    templateUrl: './verify-email-page.component.html',
    styleUrls: ['./verify-email-page.component.scss'],
})
export class VerifyEmailPageComponent implements OnInit {
    loading = false
    error: string
    title: string
    message: string

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private merchantService: MerchantService, private authenticationService: AuthenticationService) {}

    ngOnInit(): void {
        this.activatedRoute.params.forEach((params) => {
            if (params['clientKey'] && params['token']) {
                const emailVerificationTokenReceived = new EmailVerificationToken()
                emailVerificationTokenReceived.uid = params['clientKey']
                emailVerificationTokenReceived.token = params['token']
                this.loading = true
                this.authenticationService.verifyEmail(emailVerificationTokenReceived).subscribe(
                    (response) => {
                        if (response.successful) {
                            setTimeout(() => {
                                if (this.authenticationService.auth.currentUser) {
                                    this.loading = false
                                    this.router.navigate([`client/${emailVerificationTokenReceived.uid}`])
                                } else {
                                    this.loading = false
                                    this.title = 'Email Verified!'
                                }
                            }, 1000)
                        } else {
                            console.log('error')
                            this.title = 'Error'
                        }
                        this.message = response.displayMessage
                    },
                    (error) => {
                        this.loading = false
                        this.error = error.message
                    }
                )
            }
        })
    }
}
